module.exports = __webpack_public_path__ + "static/09-bdee906c411546327366543167baa539.jpg";